import React, {useCallback} from "react";
import {Button} from "antd";
import {DownloadOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import {useStore} from "hooks/useStore";
import {useFetch} from "hooks/useFetch";
import {useApplicationExport} from "../common/useApplicationExport";
import {ApplicationFilters} from "./ApplicationFilters";
import {ApplicationsTable} from "./ApplicationsTable";

export const ApplicationList = ({type, filters, queryParams, setFilters}) => {
    const {t} = useTranslation(["applications"]);
    const stores = useStore();
    const [exporting, exportApplications] = useApplicationExport(type);

    const handleFiltersChange = useCallback(
        changes => setFilters(previous => ({...previous, ...changes, skip: 0})),
        [setFilters]
    );

    const [loading, applications] = useFetch({
        fetchFn: stores.applicationStore.getApplications.bind(null, type, queryParams),
        defaultDataValue: {},
        dependencies: [JSON.stringify(queryParams)]
    });

    const handleExport = () => {
        const {skip, limit, ...exportParams} = queryParams;
        return exportApplications(exportParams);
    };

    return (
        <>
            <ApplicationFilters
                type={type}
                filters={filters}
                onChange={handleFiltersChange}
                extra={
                    <Button icon={<DownloadOutlined />} loading={exporting} onClick={handleExport}>
                        {t("list.excel.button", {ns: "applications"})}
                    </Button>
                }
            />
            <ApplicationsTable
                type={type}
                rows={applications?.data?.rows || []}
                total={applications?.data?.dataCount || 0}
                loading={loading}
                pagination={filters}
                onPageChange={(page, pageSize) =>
                    setFilters(previous => ({
                        ...previous,
                        skip: (page - 1) * pageSize,
                        limit: pageSize
                    }))
                }
            />
        </>
    );
};
